export default __webpack_public_path__ + "f3a1705f2f32c9933f62f5b7f6f662e2.png";